interface Props {
  /*
   wrapper render condition
 */
  condition: boolean;
  /*
    Wrapper Component
  */
  wrapper: (element: JSX.Element) => JSX.Element;
  /* 
  Component to be wrapped if the condition is true 
  */
  children: JSX.Element;
}

export const ConditionalWrapper = (props: Props) => {
  return props.condition ? props.wrapper(props.children) : props.children;
};
